// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import AdminLoginPanel from '../authentication/AdminLoginPanel';
import AdminDashboard from '../AdminPanelDasbord/AdminDashboard';
import AdminProfile from '../AdminPanelDasbord/AdminProfile';
import ForgotPassword from '../authentication/ForgotPassword';
import ForgotPasswordVerificationCode from '../authentication/ForgotPasswordVerificationCode';
import ChangePassword from '../authentication/ChangePassword';
import PrivacyPolicy from '../authentication/PrivacyPolicy';
import TermsofService from '../authentication/TermsofService';

const App = () => {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<AdminLoginPanel />} />
          <Route path="/whooska/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/whooska/admin/Profile" element={<AdminProfile />} />
          <Route path="/whooska/admin/Forgot/Password" element={<ForgotPassword />} />
          <Route path="/whooska/admin/ForgotPasswordVerification" element={<ForgotPasswordVerificationCode />} />
          <Route path="/whooska/admin/reports/Change/Password" element={<ChangePassword />} />
          <Route path="/whooska/admin/Privacy/Policy" element={<PrivacyPolicy />} />
          <Route path="/whooska/admin/Terms/of/Service" element={<TermsofService />} />

        </Routes>
    </Router>
  );
};

export default App;
